/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('EmailManagerCtrl', ["$rootScope", '$scope', '$http', 'IntentService', 'NetworkService', "MainService", function ($rootScope, $scope, $http, IntentService, NetworkService, MainService) {

        $scope.editMode = false;
        $scope.editTemplate = {}
        $scope.sendToPositon = false;
        $scope.templateType = 0             // 0 == normal, 1 = register

        NetworkService.getEvents(function (data) {
            $scope.selectedEvent = data[0]
            $scope.events = data
            setTimeout(function () {
                $("#eventselect").material_select()
            }, 1000)

        })

        $scope.getEmailAdresses = function()
        {
            console.log($scope.sendToPosition)
            NetworkService.getEmailAdresses($scope.selectedEvent, $scope.sendToPosition, function(data){
                MainService.setDialogData("dialog_emailApproovalCtrl", {emails:data, template:$scope.editTemplate.Templatename,position_id:$scope.sendToPosition})
                $rootScope.$emit("render_dialog_emailApproovalCtrl")
                $("#dialog_emailApproovalCtrl").modal("open")()
            })
        }
        $scope.eventChanged = function ()
        {
            NetworkService.getPositionenForEvent($scope.selectedEvent, function (data) {
                $scope.sendToPosition = data[0]
                console.log($scope.sendToPosition)
                $scope.positionen = data
                $scope.sendToPosition = data[0]
                setTimeout(function () {
                    $("#position_select").material_select()
                }, 1000)
            })
        }
        $scope.auto_paar = ["anrede",
            "vorname",
            "nachname",
            "partner_anrede",
            "partner_vorname",
            "partner_nachname",
            "position_name",
            "position_beschreibung",
            "akzeptier_link",
            "ablehn_link",
            "schicht_name",
            "start",
            "ende",
            "event_name",
            "event_email"]

        $scope.suggestsForMoveUser = ["anrede",
            "vorname",
            "nachname",
            "position_von_name",
            "position_zu_name",
            "position_von_beschreibung",
            "position_zu_beschreibung",
            "schicht_von_name",
            "schicht_zu_name",
            "start",
            "ende",
            "event_name",
            "event_email",
            "tshirt",
            "essen",
            "eingesetzt_als",
            "ausloeser_email",
            "ausloeser_vorname",
            "ausloeser_nachname"]

        $scope.auto_reservierung_admin = ["anrede",
            "vorname",
            "nachname",
            "position_name",
            "position_beschreibung",
            "schicht_name",
            "start",
            "ende",
            "event_name",
            "event_email",
            "ausloeser_email",
            "ausloeser_vorname",
            "ausloeser_nachname"]

        $scope.auto_passwort_vergessen = ["anrede",
            "vorname",
            "nachname",
            "reset_link"]

        $scope.suggestsForReserve = ["anrede",
            "vorname",
            "nachname",
            "position_name",
            "position_beschreibung",
            "schicht_name",
            "start",
            "ende",
            "event_name",
            "event_email",
            "tshirt",
            "essen"]

        $scope.suggestsForDecline = ["anrede",
            "vorname",
            "nachname",
            "position_name",
            "position_beschreibung",
            "schicht_name",
            "start",
            "ende",
            "event_name",
            "event_email",
            "tshirt",
            "essen",
            "begruendung",
            "ausloeser_email",
            "ausloeser_vorname",
            "ausloeser_nachname"]

        $scope.suggestsForAll = ["anrede",
            "vorname",
            "nachname",
            "position_name",
            "event_name",
            "eingesetzt_als",
            "start",
            "ende",
            "registrierungslink"]

        $scope.suggestsForAcceptEmail = ["anrede",
            "vorname",
            "nachname",
            "position_name",
            "position_beschreibung",
            "schicht_name",
            "start",
            "ende",
            "event_name",
            "tshirt",
            "essen",
            "eingesetzt_als",
            "ausloeser_email",
            "ausloeser_vorname",
            "ausloeser_nachname"]

        $scope.suggestsForUpdateEmailEmail = ["anrede",
            "vorname",
            "nachname",
            "bestaetigungs_link"]

        $scope.suggestsForEmail = ["anrede",
            "vorname",
            "nachname",
            "registrierungslink"]

        $scope.suggests = $scope.suggestsForAll


        NetworkService.getMitarbeiterDetails(UserId, function (data) {
            $rootScope.$emit("setNavName", data);
        })

        $scope.openRemoveTemplateDialog = function (template)
        {
            $rootScope.$emit("updateRemoveTemplate", template);
            $("#dialog_removeTemplate").modal("open")()
        }

        $scope.repaint = function () {
            NetworkService.getTemplates(function (data) {
                $scope.templates = data;
            })
        }
        $rootScope.$on("repaint", function () {
            $scope.repaint();
        })
        $scope.openEditMode = function ($event, template)
        {
            $scope.editMode = true
            $scope.editTemplate = template
            if (template.Templatename == "registrierung")
            {
                $scope.templateType = 1
                $scope.suggests = $scope.suggestsForEmail
            } else if (template.Templatename.indexOf("auto_event_position_accept") != -1)
            {
                $scope.templateType = 2
                $scope.suggests = $scope.suggestsForAcceptEmail
            } else if (template.Templatename == "E-Mail Adresse geändert")
            {
                $scope.templateType = 3
                $scope.suggests = $scope.suggestsForUpdateEmailEmail
            } else if (template.Templatename == "auto_user_verschoben")
            {
                $scope.templateType = 4
                $scope.suggests = $scope.suggestsForMoveUser
            } else if (template.Templatename == "auto_reservierung")
            {
                $scope.templateType = 5
                $scope.suggests = $scope.suggestsForReserve
            } else if (template.Templatename == "auto_ablehnen")
            {
                $scope.templateType = 6
                $scope.suggests = $scope.suggestsForDecline
            } else if (template.Templatename == "auto_reservierung_admin")
            {
                $scope.templateType = 7
                $scope.suggests = $scope.auto_reservierung_admin
            } else if (template.Templatename == "auto_passwort_vergessen")
            {
                $scope.templateType = 8
                $scope.suggests = $scope.auto_passwort_vergessen
            } else if (template.Templatename == "auto_paar")
            {
                $scope.templateType = 9
                $scope.suggests = $scope.auto_paar
            } else
            {
                $scope.templateType = 0
                $scope.suggests = $scope.suggestsFor
            }

            animateIt($event)
        }
        $scope.openAddEmailTemplateDialog = function () {

            $("#dialog_addEmailTemplate").modal("open")()
        }

        $scope.updateTemplate = function ()
        {
            var data = $scope.editTemplate
            NetworkService.updateTemplate(data, function (data) {
                console.log(data)
            })
        }

        $scope.goBack = function ()
        {
            $scope.editMode = false;
            animateItBack()
        }


        NetworkService.getTemplates(function (data) {
            $scope.templates = data;
        })

        $(document).ready(function () {
            
            $(':regex(id,taTextElement[0-9]*)').attr("spellcheck", "true")

            $("body").on("click", function (e) {
                var suggests = $("#suggests")[0];
                console.log(e.target == suggests)
                if (e.target != suggests)
                {
                    $scope.hideSuggests()
                }
            })
        });

        $scope.sendToChanged = function ()
        {
            if ($scope.sendToPosition != "")
            {
                $scope.sendToPositon = true;
            } else
            {
                $scope.sendToParticipants = false;
            }
        }

        $scope.checkInput = function ()
        {
            if ($scope.editTemplate != undefined)
            {
                //var last = $scope.editTemplate.text.slice(-1);

            }
            console.log($scope.getCharacterPrecedingCaret())
        }

        $scope.openSuggests = function ()
        {
            var pos = getSelectionCoords();
            $("#suggests").css("left", pos.x + "px")
            $("#suggests").css("top", pos.y + "px")
            $("#suggests").fadeIn()
        }

        $scope.hideSuggests = function ()
        {
            $("#suggests").fadeOut()
        }

        $scope.setSuggest = function (suggest)
        {
            var el = $("text-angular[name=htmlcontentEdit]").find("div[contenteditable]")
            el.focus()
            $scope.hideSuggests()
            restoreSelection($scope.range)
            var suggest = suggest + "]"
            insertTextAtCursor(suggest)
            range = $scope.range
        }

        function getSelectionCoords(win) {
            win = win || window;
            var doc = win.document;
            var sel = doc.selection, range, rects, rect;
            var x = 0, y = 0;
            if (sel) {
                if (sel.type != "Control") {
                    range = sel.createRange();
                    range.collapse(true);
                    x = range.boundingLeft;
                    y = range.boundingTop;
                }
            } else if (win.getSelection) {
                sel = win.getSelection();
                if (sel.rangeCount) {
                    range = sel.getRangeAt(0).cloneRange();
                    if (range.getClientRects) {
                        range.collapse(true);
                        rects = range.getClientRects();
                        if (rects.length > 0) {
                            rect = rects[0];
                        }
                        x = rect.left;
                        y = rect.top;
                    }
                    // Fall back to inserting a temporary element
                    if (x == 0 && y == 0) {
                        var span = doc.createElement("span");
                        if (span.getClientRects) {
                            // Ensure span has dimensions and position by
                            // adding a zero-width space character
                            span.appendChild(doc.createTextNode("\u200b"));
                            range.insertNode(span);
                            rect = span.getClientRects()[0];
                            x = rect.left;
                            y = rect.top;
                            var spanParent = span.parentNode;
                            spanParent.removeChild(span);

                            // Glue any broken text nodes back together
                            spanParent.normalize();
                        }
                    }
                }
            }
            return {x: x, y: y};
        }

        $(document).ready(function () {
            var el = $("text-angular[name=htmlcontentEdit]").find("div[contenteditable]")


            el.on("keyup", function () {
                var char = $scope.getCharacterPrecedingCaret()
                var el = $("text-angular[name=htmlcontentEdit]").find("div[contenteditable]")

                if (char == "[")
                {
                    $scope.range = saveSelection()
                    $scope.openSuggests()
                }
            })
        })

        function insertTextAtCursor(text) {
            var sel, range, html;
            if (window.getSelection) {
                sel = window.getSelection();
                if (sel.getRangeAt && sel.rangeCount) {
                    range = sel.getRangeAt(0);
                    range.deleteContents();
                    var node = document.createTextNode(text)

                    range.insertNode(node);

                    range.setStartAfter(node);
                    range.setEndAfter(node);
                    sel.removeAllRanges();
                    sel.addRange(range);
                }
            } else if (document.selection && document.selection.createRange) {
                document.selection.createRange().text = text;
            }
        }
        function saveSelection() {
            if (window.getSelection) {
                sel = window.getSelection();
                if (sel.getRangeAt && sel.rangeCount) {
                    return sel.getRangeAt(0);
                }
            } else if (document.selection && document.selection.createRange) {
                return document.selection.createRange();
            }
            return null;
        }

        function restoreSelection(range) {
            if (range) {
                if (window.getSelection) {
                    sel = window.getSelection();
                    sel.removeAllRanges();
                    sel.addRange(range);
                } else if (document.selection && range.select) {
                    range.select();
                }
            }
        }

        $scope.getCharacterPrecedingCaret = function () {
            var containerEl = $("text-angular[name=htmlcontentEdit]").find("div[contenteditable]")[0]
            var precedingChar = "", sel, range, precedingRange;
            if (window.getSelection) {
                sel = window.getSelection();
                if (sel.rangeCount > 0) {
                    range = sel.getRangeAt(0).cloneRange();
                    range.collapse(true);
                    range.setStart(containerEl, 0);
                    precedingChar = range.toString().slice(-1);
                }
            } else if ((sel = document.selection) && sel.type != "Control") {
                range = sel.createRange();
                precedingRange = range.duplicate();
                precedingRange.moveToElementText(containerEl);
                precedingRange.setEndPoint("EndToStart", range);
                precedingChar = precedingRange.text.slice(-1);
            }
            return precedingChar;
        }

    }])
